// extracted by mini-css-extract-plugin
export default {"cutLine":"free-draw-preview_cutLine__ZYWSQ","trace":"free-draw-preview_trace__2VOoj"};